<template>
    <div>
        <CheckboxInput
            v-for="priv in filteredPrivileges"
            :key="priv.id"
            :label="priv.name"
            :value="hasPrivilege(priv)"
            @input="togglePrivilege(priv)"
        >
            <template v-slot:label>
                <span class="font-weight-bold">{{ priv.name }}</span>
            </template>
            <template v-slot:footer>
                {{ priv.description }}
            </template>
        </CheckboxInput>
    </div>
</template>

<script>
import CheckboxInput from '../Inputs/CheckboxInput.vue';

export default {
    props: {
        role: {
            type: Object,
            required: true,
        }
    },
    async mounted() {
        await this.fetchPrivileges()
    },
    data() {
        return {
            privileges: [],
        }
    },
    methods: {
        async fetchPrivileges() {

        	/*
            const storedPrivileges = sessionStorage.getItem('allprivileges')

            if (storedPrivileges) {
                this.privileges = JSON.parse(storedPrivileges)
                return
            }
            */

            try {
                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/privileges/all`, {
                    method: 'GET'
                })

                if (res.status !== 'SUCCESS') {
                    this.$store.commit("openDialog", {
                        title: this.$t("something-went-wrong"),
                        content: this.$t('fetch-privs-fail-msg'),
                        confirmCallBack: this.closeModal()
                    })
                    return
                }

                this.privileges = res.privileges

                //sessionStorage.setItem('allprivileges', JSON.stringify(this.privileges))
            }
            catch (err) {
                this.$log.error.call(this, err)
            }
        },
        hasPrivilege(privilege) {
            return this.role.privileges.includes(privilege.id)
        },
        togglePrivilege(privilege) {
            const privilegeIndex = this.role.privileges.findIndex(id => id === privilege.id)

            if (privilegeIndex > -1) this.role.privileges.splice(privilegeIndex, 1)
            else this.role.privileges.push(privilege.id)
        },
    },
    components: {
        CheckboxInput,
    },
    computed: {
        filteredPrivileges() {
            return this.privileges.filter(priv => 
                priv.module === null || this.$config.hasModule(priv.module)
            );
        }
    }
}
</script>
